module.exports = __webpack_public_path__ + "media/img/logos/2023/easter-1289eb62f02754ebaff3cda87d3af50d.svg";